import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "redux/reducers";
import { setFilters } from "redux/actions/catalog";

import Spinner from "components/Common/misc/Spinner";
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";

import CatalogSkeleton from "./CatalogSkeleton";
import { medaccessFilters, medaccessMenu } from "data/menus/catalogMenu";

import { generatePageTitle } from "utils/general.utils";
import { fetchMedAccessCatalogData, resetFilters } from "redux/actions/medaccess";
import { useAuth } from "contexts/AuthContext";
import { fetchMedAccessSubscriptions } from "redux/actions/subscriptions";

const MedAccessList = React.lazy(
  () => import("./ChildComponents/Preview/MedAccessList")
);

const MedAccess = () => {
  const { currentUser } = useAuth();
  const dispatch = useDispatch();
  const location = useLocation();
  const { medaccess } = useSelector((state: RootState) => state);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    dispatch(fetchMedAccessCatalogData(setLoading));

    if (currentUser.email !== "support@idataresearch.net" &&
        currentUser.email !== "marketing@idataresearch.net") {
      dispatch(fetchMedAccessSubscriptions(currentUser.usergroupData.id));
    }
  }, []);

  useEffect(() => {
    dispatch(resetFilters());
  }, [medaccess.filters.filter, medaccess.categories.length, dispatch]);

  // Change filter based on pathname
  useEffect(() => {
    switch (location.pathname) {
      case "/medaccess/subscriptions":
        dispatch(setFilters("filter", "Subscriptions"));
        dispatch(setFilters("subscribed", true));
        document.title = generatePageTitle("Subscriptions");
        break;
      case "/medaccess/favorites":
        dispatch(setFilters("filter", "Favorites"));
        dispatch(setFilters("subscribed", false));
        document.title = generatePageTitle("Favorites");
        break;
      default:
        dispatch(setFilters("filter", "All MedAccess"));
        dispatch(setFilters("subscribed", false));
        document.title = generatePageTitle("All MedAccess");
        break;
    }
  }, [dispatch, location.pathname]);

  if (loading) {
    return (
      <>
        <Header />
        <Spinner />
        <Footer />
      </>
    );
  } else {
    return (
      <>
        <Header />
        <Container>
          <CatalogSkeleton
            menu={medaccessMenu}
            filters={medaccessFilters}
            list={<MedAccessList />}
            hideFilters={false}
            parent={"medaccess"}
            sectionName={"MedAccess Catalog"}
          />
        </Container>
        <Footer />
      </>
    );
  }
};

const Container = styled.div`
  background-color: #f6f8f9;
  color: #000;
  /* min-height: 100vh; */
  overflow-y: auto;
  width: 100%;
`;

export default MedAccess;
